import React,{useState,useEffect}  from "react";
const BlockScroll = ({ data }) => {
    return (
        <div id={data.key}>
        </div>
    );
  };
  
  export default BlockScroll;